import { Box, Button, ButtonProps } from '@mui/material';
import { PropsWithChildren } from 'react';

export const PrimaryButton = ({ children, ...rest }: ButtonProps) => {
  return (
    <Button {...rest} variant="contained" color="primary" className="cc-button cc-primary-button">
      {children}
    </Button>
  );
};

export const SecondaryButton = ({ children, ...rest }: ButtonProps) => {
  return (
    <Button {...rest} variant="text" color="primary" className="cc-button cc-secondary-button">
      {children}
    </Button>
  );
};

export const TertiaryButton = ({ children, ...rest }: ButtonProps) => {
  return (
    <Button {...rest} variant="text" color="light-grey" className="cc-button cc-tertiary-button">
      {children}
    </Button>
  );
};

export const DangerButton = ({ children, ...rest }: ButtonProps) => {
  return (
    <Button {...rest} variant="contained" color="error" className="cc-button cc-danger-button">
      {children}
    </Button>
  );
};

type ButtonBoxProps = PropsWithChildren<{}>;

export const ButtonBox = ({ children }: ButtonBoxProps) => {
  return (
    <Box data-role="button-box" sx={{ pt: 2, textAlign: 'right', '& button:not(:first-of-type)': { ml: 1 } }}>
      {children}
    </Box>
  );
};
